import React, { Component } from "react";
// import restService from '../../../../../../services/restService';
import Table from "../../../../Components/Table/index";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Modal } from "semantic-ui-react";
import { Button } from "reactstrap";
import Fade from "react-reveal/Fade";
import Select from "react-select";
import { Input, InputGroup } from "reactstrap";
import { Checkbox } from "@material-ui/core";
import swal from "sweetalert";
import Errors from "../../../../Components/Errors/index";
import axios from "axios";
import { Services } from "../../../Services";
import ReportAsing from "../reportAssig";

const styles = {
  background: "red",
};

const config = [
  { label: "Name", id: "Name", type: "simple" },
  { label: "Last Name", id: "LastName", type: "simple" },
  { label: "Position", id: "Position", type: "simple" },
  { label: "Email", id: "Email", type: "simple" },
  { label: "Password", id: "Password", type: "simple" },
  { label: "Role", id: "Rol", type: "simple" },
  { label: "Telephone", id: "Telephone", type: "simple" },
];
class ListUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verPass: false,
      selecccion: null,
      Changedocument: false,
      Changereport: false,
      dataReport: {},
      reportsId: [],
      statusDocuemtens: [],
      userId: "",
      idDefault: "",
      table1: [],
      table2: [],
      clientes: [],
      allClientes: [],
      checkbox: false,
      check: [],
      Roles: [],
      clientesADD: [],
      newClientesDefault: [],
      rows: [],
      edit: false,
      show: false,
      error: {
        open: false,
        message: "",
        type: "admin",
      },
      columnsContact: [
        { label: "ID", key: "CustomerId" },
        { label: "Customer Name", key: "Name" },
        // { label: 'Customer Code', key: 'CustomerCode' },
        { label: "NIT", key: "NIT" },
        { label: "Telephone", key: "Telephone" },
        { label: "Country", key: "Country" },
        { label: "Logo", key: "URLLogo" },
      ],
      itemsContact: [],
      columnsUser: [
        { label: "ID", key: "ID" },
        { label: "Name", key: "Name" },
        { label: "last Name", key: "lastname" },
        { label: "Email", key: "Email" },
        { label: "Role", key: "Role" },
      ],
      itemsUser: [
        {
          ID: 1,
          Name: "carlos rene ",
          lastname: "34kl",
          Email: "12rd",
          Role: "7713241142",
        },
      ],
      country: [],
      user: {
        Name: "",
        LastName: "",
        Position: "",
        Email: "",
        Password: "",
        Rol: "",
        Telephone: "",
      },
      items: [],
      contact: {
        Name: "",
        LastName: "",
        Position: "",
        Telephone: "",
        Email: "",
      },
      refres: false,
      CreateFormData: [],
      CreateForAdd: [],
      Form: [],
      active: false,
      orders: [],
      data: [],
      columns: [
        {
          label: "ID",
          key: "UserId",
          custom: (value) => (
            <em
              onClick={() =>
                this.setState({ active: !this.state.active }, () => {
                  this.modalCustomer(value);
                })
              }
            >
              {" "}
              <label style={{ color: "#349ced" }}>{value.UserId}</label>{" "}
            </em>
          ),
        },
        { label: "Name", key: "Name" },
        { label: "Last Name", key: "LastName" },
        { label: "Position", key: "Position" },
        { label: "Email", key: "Email" },
        { label: "Rol", key: "Rol" },
        { label: "Telephone", key: "Telephone" },
        { label: "Creation Date", key: "CreateDate" },
        { label: "Associated Clients", key: "AssociatedCustomer" },
        { label: "Action", key: "", custom: (value) => this.custom1(value) },
      ],
      columnsSetrings: [
        { label: "ID", key: "UserId" },
        { label: "Name", key: "Name" },
        { label: "Last Name", key: "LastName" },
      ],
    };
  }

  custom1 = (value) => (
    <em
      onClick={() => this.validateDeleteUser(value)}
      className="fa-2x mr-2 far fa-trash-alt"
      style={{ color: "#297AB9" }}
    ></em>
  );
  custom3 = (value) => (
    <em
      onClick={() => this.deleteCcontact(value)}
      className={this.state.edit ? "fa-2x mr-2 far fa-trash-alt" : ""}
      style={{ color: "#297AB9" }}
    ></em>
  );

  deleteCcontact = (name) => {
    let data = name.ContactId;
    axios
      .delete(`${Services.DeleteContact.path}admin/deleteContact/${data}`)
      .then((response) => {
        this.modalCustomer();
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  validateDeleteUser = (value) => {
    let id = `${value.Name}`;
    swal({
      title: "Are you sure that you want to delete this User?",
      text: id,
      icon: "warning",
      buttons: true,
    }).then((yeah) => {
      if (yeah) this.props.deleteUser(value);
    });
  };

  cheked = (name) => {
    let newClientes = this.state.clientes.map((e) => {
      if (e.CustomerId === Number(name.target.id)) {
        e.checked = !e.checked;
      }
      return e;
    });
    this.setState(
      {
        clientes: newClientes,
      },
      () => {
        this.table1();
        this.table2();
      }
    );
  };
  modalCustomer = (name) => {
    // console.log("name--->>>", name);
    let { Roles } = this.state;
    // console.log("Roles", this.state.Roles);
    let newselecccion = null;
    Roles.map((e) => {
      if (name.RolId === e.value) {
        newselecccion = e;
      }
      return e;
    });

    let id = name.UserId;
    this.setState(
      {
        idDefault: id,
      },
      () => this.getRelacionDocuementsReports()
    );
    let user = {
      Name: name.Name,
      LastName: name.LastName,
      Position: name.Position,
      Email: name.Email,
      Password: "",
      Rol: name.Rol,
      Telephone: name.Telephone,
      RoleId: name.RolId,
      UserId: name.UserId,
    };
    let ids = name.CustomerIds.split(",");
    let newCliente = [];
    let newclientesADD = [];
    let newClientesDefault = [];
    var findDefault = false;
    if (
      this.state.newClientesDefault.length > 0 &&
      id === this.state.idDefault2
    ) {
      findDefault = true;
    }

    this.state.allClientes.map((e) => {
      var findCustomer = false;
      ids.map((f) => {
        if (Number(f) === e.CustomerId) {
          findCustomer = true;
        }
        return 0;
      });
      if (!findCustomer) {
        e.checked = false;
        newCliente.push(e);
      } else {
        e.checked = true;
        if (!findDefault) {
          newclientesADD.push(e);
          newClientesDefault.push(e);
        }
      }
      return 0;
    });

    if (findDefault) {
      newclientesADD = this.state.newClientesDefault;
    }
    axios
      .get(`${Services.GetInfoUser.path}admin/infoUser/${id}`, {})
      .then((response) => {
        // console.log("response.data.resp--->", response.data.resp);
        this.setState(
          {
            selecccion: newselecccion,
            itemsContact: response.data.resp,
            user,
            edit: false,
            clientes: newCliente,
            clientesADD: newclientesADD,
            newClientesDefault: newClientesDefault,
          },
          () => {
            this.buildRows();
            this.table2();
            this.table1();
            this.getRelacionDocuementsReports();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };
  componentDidMount = () => {
    this.setState({
      userId: this.props.userId,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.errorValidate) {
      this.setState({
        // error: {
        //   message: "Dato incorrecto, favor de verificarrrrrrrr",
        //   open: true,
        //   type: "error",
        // }
        // ,
        active: true,
      });
      if (nextProps.modal) {
        this.setState({
          // active: true,
          edit: true,
        });
      } else {
        this.setState({
          // active: false,
          edit: true,
        });
      }
      let dataArray = nextProps.customerList.map((f) => {
        f.checked = false;
        return f;
      });

      this.setState(
        {
          userId: nextProps.userId,
          data: nextProps.UserList,
          CreateFormData: nextProps.CreateFormData,
          Form: nextProps.Form,
          Roles: nextProps.Roles,
          clientes: dataArray,
          allClientes: dataArray,
        },
        () => {
          this.buildFormCreate();
          this.table1();
          this.table2();
        }
      );
    } else {
      if (nextProps.modal) {
        this.setState({
          active: true,
          edit: true,
        });
      } else {
        this.setState({
          active: false,
          edit: false,
        });
      }
      let dataArray = nextProps.customerList.map((f) => {
        f.checked = false;
        return f;
      });

      this.setState(
        {
          userId: nextProps.userId,
          data: nextProps.UserList,
          CreateFormData: nextProps.CreateFormData,
          Form: nextProps.Form,
          Roles: nextProps.Roles,
          clientes: dataArray,
          allClientes: dataArray,
        },
        () => {
          this.buildFormCreate();
          this.table1();
          this.table2();
        }
      );
    }
  };
  handleSearch = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () =>
      this.setSearch(name === "search2" ? name : "")
    );
  };

  setSearch = (id) => {
    let search = id ? this.state.search2 : this.state.search;
    let cliente = id ? [...this.state.clientesADD] : [...this.state.clientes];
    let haveSearch = false;
    if (search.length > 0) {
      haveSearch = true;
    }
    let all = cliente;
    let newAll = all.map((item) => {
      const nameData = item.Name ? item.Name.toUpperCase() : "".toUpperCase();
      const RFC = item.RFC ? item.RFC.toUpperCase() : "".toUpperCase();
      const idData = item.CustomerId
        ? item.CustomerId.toString().toUpperCase()
        : "".toUpperCase();
      const textData = search.toUpperCase();
      if (
        nameData.indexOf(textData) > -1 ||
        idData.indexOf(textData) > -1 ||
        RFC.indexOf(textData) > -1
      ) {
        item.hidden = false;
      } else {
        item.hidden = haveSearch ? true : false;
      }
      return item;
    });
    if (id) {
      this.setState({ clientesADD: newAll }, () => this.table2());
    } else {
      this.setState({ clientes: newAll }, () => this.table1());
    }
  };
  getRelacionDocuementsReports = () => {
    let id = this.state.idDefault;
    // axios.get(`${Services.GET_DOCUMENTS_RELATION.path}documents/relation/${id}`, {
    // }).then(response => {
    axios
      .get(`${Services.GET_REPORTS_RELATION.path}report/relation/${id}`, {})
      .then((response) => {
        let newArr = [];
        response.data.data.map((e) => {
          newArr.push(e.ReportId);
          return e;
        });
        this.setState({
          reportsId: newArr,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
    // this.setState({
    //   statusDocuemtens: response.data.data,
    // });
    // }).catch(error => {
    //   console.warn(error);
    // });
  };

  buildRows = () => {
    let { user } = this.state;
    let rows = config.map((e) => {
      return (
        <div
          className={
            e.id === "CustomerName"
              ? "col-md-4 col-lg-3 col-sm-6"
              : "col-md-4 col-lg-2 col-sm-6"
          }
          style={{ paddingTop: "1%" }}
        >
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-6">
              <span style={{ color: "#545350", fontWeight: "bold" }}>
                {e.label}
              </span>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-6">
              <span>
                {user[e.id]
                  ? user[e.id]
                  : e.label === "Password"
                    ? "********"
                    : ""}
              </span>
            </div>
          </div>
        </div>
      );
    });
    this.setState({
      rows,
    });
  };

  handleChangeAdd = (name) => (event) => {
    let { contact } = this.state;
    contact[name] = event.target.value;
    this.setState({
      contact,
    });
  };

  handleChange = (name) => (event) => {
    // console.log("name", name);

    let { user } = this.state;

    if (name === "Password") {
      let value = event.target.value;
      this.setState({
        show: true,
      });

      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/
      );
      if (emailRegex.test(value)) {
        // console.log("se cuemple");

        this.setState(
          {
            passcorrect: true,
          },
          () => {
            this.buildFormCreate();
          }
        );
        document
          .getElementById("pass_diferentes")
          .setAttribute("hidden", "hidden");
      } else {
        this.setState(
          {
            passcorrect: false,
          },
          () => {
            this.buildFormCreate();
          }
        );
        document.getElementById("pass_diferentes").removeAttribute("hidden");
      }
    }

    user[name] = event.target.value;
    this.setState(
      {
        user,
      },
      () => {
        this.buildFormCreate();
      }
    );
  };

  handleChangeSelect = (selected) => (event) => {
    if (event && event.value) {
      let { user } = this.state;
      user[selected] = event.value;

      this.setState({ selected, selecccion: event }, () => {
        this.buildFormCreate();
      });
    } else {
      let { user } = this.state;
      user[selected] = "";
      this.setState({ selected, selecccion: null }, () => {
        this.buildFormCreate();
      });
    }
  };

  verPassword = () => {
    this.setState(
      {
        verPass: !this.state.verPass,
      },
      () => {
        this.buildFormCreate();
      }
    );
  };

  buildFormCreate = () => {
    const { Form, user, Roles, show } = this.state;
    // console.log("user", user);
    // console.log("this.state.verPass", this.state.verPass);

    let CreateFormData = Form.editUser.map((e, i) => {
      if (e.type === "Input")
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              {" "}
              <span id={e.label} style={e.style}>
                <label>
                  {e.label} {e.required === true ? <span>*</span> : ""}
                </label>
              </span>
            </Fade>
            <Row>
              <Col xs={e.id2 ? 9 : 12} style={{ paddingRight: e.id2 ? 0 : "" }}>
                <Input
                  id={e.id}
                  disabled={this.state.edit === false ? true : false}
                  required
                  type={
                    e.datatype ? (this.state.verPass ? "info" : "Password") : ""
                  }
                  placeholder={e.id === "Password" ? "Add New Password" : ""}
                  name={e.id}
                  value={user[e.id]}
                  maxlength={e.maxlength}
                  minlength={e.minlength}
                  onChange={this.handleChange(e.id)}
                  max={e.max}
                />
              </Col>
              {e.id2 ? (
                <Col xs={3} style={{ padding: 0 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="button"
                    onClick={this.verPassword}
                  >
                    <i className="fas fa-eye" style={{ padding: 0 }}></i>
                  </Button>
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Fade>
              <label style={e.style}>{e.error}</label>
            </Fade>
            {e.id2 === "Passwordedit" && show === true ? (
              <Fade left opposite>
                <div
                  style={{
                    padding: "",
                    marginTop: "",
                    color: "#BA2B30",
                    fontSize: "12px",
                  }}
                  className="_alert"
                  id="pass_diferentes"
                  hidden={this.state.passcorrect}
                >
                  <label>
                    <b>The password must be composed of</b>
                  </label>
                  <br></br>
                  <label>* Minimum 8 characters and maximum 15</label>
                  <label>* At least one capital letter</label>
                  <label>* A special character (*! $% &?).</label>
                </div>
              </Fade>
            ) : (
              <></>
            )}
          </div>
        );
      else if (e.type === "Select")
        return (
          <div className={e.class} key={e.id}>
            <Fade left opposite>
              <span id={e.label} style={e.style}>
                {" "}
                <label>
                  {e.label} {e.required === true ? <span>*</span> : ""}{" "}
                </label>
              </span>
            </Fade>
            <Select
              isClearable={true}
              id={e.id}
              disabled={this.state.edit === false ? true : false}
              required
              type={e.datatype}
              name={e.name}
              value={this.state.selecccion}
              onChange={this.handleChangeSelect(e.id)}
              options={Roles}
            />
            <Fade left opposite>
              <label style={e.style}>{e.error}</label>
            </Fade>
          </div>
        );
      return e;
    });
    this.setState({
      CreateFormData,
    });
  };

  handleOnClose = () => {
    this.setState(
      {
        active: false,
        edit: false,
        contact: {
          Name: "",
          LastName: "",
          Position: "",
          Telephone: "",
          Email: "",
        },
        idDefault2: this.state.idDefault,
      },
      () => {
        this.table2();
        this.table1();
      }
    );
  };

  addAll = () => {
    let newClientes = this.state.allClientes.map((e) => {
      e.checked = false;
      return e;
    });
    this.setState({ clientes: [], clientesADD: newClientes }, () => {
      this.table2();
      this.table1();
    });
  };

  add = () => {
    let { clientes, clientesADD } = this.state;
    let allCliente = clientesADD;
    let allCliente2 = clientes.filter((e) => {
      if (!e.checked) {
        return e;
      } else {
        allCliente.push(e);
      }
      return 0;
    });
    this.setState(
      {
        clientesADD: allCliente,
        clientes: allCliente2,
      },
      () => {
        this.table2();
        this.table1();
        this.setState({
          error: {
            message: "Cliente agregado corectamente!",
            open: true,
            type: "admin",
          },
        });
      }
    );
  };

  deletAdd = () => {
    let newClientes = this.state.allClientes.map((e) => {
      e.checked = false;
      return e;
    });
    this.setState({ clientes: newClientes, clientesADD: [] }, () => {
      this.table2();
      this.table1();
    });
  };

  putUser = () => {
    // if (this.state.passcorrect) {
    let dataReport2 = {
      data: this.state.reportsId,
      userId: this.state.idDefault,
    };
    let data = {
      dataUser: this.state.user,
      itemsCUstomer: this.state.clientesADD,
      report: this.state.Changereport ? this.state.dataReport : dataReport2,
      document: this.state.Changedocument
        ? this.state.dataDocuments
        : this.state.statusDocuemtens,
    };
    this.props.saveUser(data);
    this.setState({
      newClientesDefault: this.state.clientesADD,
      dataReport: [],
      dataDocuments: [],
      Changedocument: false,
      Changereport: false,
    });
  };
  deleteCustomer = (id) => (event) => {
    let { clientes, clientesADD, allClientes } = this.state;

    let newClientes = clientes;
    allClientes.map((e) => {
      if (e.CustomerId === id) {
        e.checked = false;
        newClientes.push(e);
      }
      return 0;
    });
    let newClientesADD = clientesADD.filter((e) => {
      if (e.CustomerId !== id) {
        return e;
      }
      return 0;
    });
    this.setState(
      { clientes: newClientes, clientesADD: newClientesADD },
      () => {
        this.table2();
        this.table1();
      }
    );
  };

  table2 = () => {
    let tableADD = [];

    this.state.clientesADD.map((e, index) => {
      if (e.hidden) {
      } else {
        tableADD.push(
          <tr key={index}>
            <td>{e.CustomerId}</td>
            <td>{e.Name}</td>
            <td>{e.RFC}</td>
            <em
              onClick={this.deleteCustomer(e.CustomerId)}
              className="fa-1x mr-1 far fa-trash-alt"
              style={{ color: "#297AB9", marginTop: "15px" }}
            ></em>
          </tr>
        );
      }
      return e;
    });
    let taleAD2 = [];
    taleAD2.push(
      <Col style={{ fontSize: "12px" }} md="6">
        <InputGroup style={{ width: "486px" }}>
          <Input
            style={{ marginLeft: "-4px", height: "31px" }}
            placeholder="Customer Name"
            onChange={this.handleSearch("search2")}
          />
          <br></br>
          <em
            className="fa-2x icon-magnifier"
            style={{
              fontSize: "23px",
              marginLeft: "10px",
              color: "#a5a0a0",
              marginTop: "5px",
            }}
            onClick={""}
          ></em>
        </InputGroup>
        <br></br>
        <div
          style={{
            overflowY: "auto",
            width: "500px",
            height: "300px",
            overflowX: "hidden",
          }}
          className="table-wrapper-scroll-y"
        >
          <table className="table">
            <thead>
              <tr>
                <th className="eventsTableHeader">ID</th>
                <th className="eventsTableHeader">Name</th>
                <th className="eventsTableHeader">RFC</th>
                <th className="eventsTableHeader"></th>
              </tr>
            </thead>
            <tbody className="eventsTableBody">{tableADD}</tbody>
          </table>
        </div>
      </Col>
    );
    this.setState({
      table2: taleAD2,
    });
  };

  table1 = () => {
    let table = [];
    // console.log("clientes", this.state.clientes);
    this.state.clientes.map((e, index) => {
      if (e.hidden) {
      } else {
        table.push(
          <tr key={index}>
            <th>
              <Checkbox
                checked={e.checked}
                onChange={this.cheked}
                value={e.checked}
                id={e.CustomerId}
              />
            </th>
            <td>{e.CustomerId}</td>
            <td>{e.Name}</td>
            <td>{e.RFC}</td>
          </tr>
        );
      }
      return e;
    });

    let tale2 = [];
    tale2.push(
      <Col style={{ fontSize: "12px" }} md="6">
        <InputGroup style={{ width: "486px" }}>
          <Input
            style={{ marginLeft: "-4px", height: "31px" }}
            placeholder="Customer Name"
            onChange={this.handleSearch("search")}
          />
          <br></br>
          <em
            className="fa-2x icon-magnifier"
            style={{
              fontSize: "23px",
              marginLeft: "10px",
              color: "#a5a0a0",
              marginTop: "5px",
            }}
            onClick={""}
          ></em>
        </InputGroup>
        <br></br>
        <div
          style={{
            overflowY: "auto",
            width: "500px",
            height: "300px",
            overflowX: "hidden",
          }}
          className="table-wrapper-scroll-y"
        >
          <table className="table">
            <thead>
              <tr>
                <th className="eventsTableHeader"></th>
                <th className="eventsTableHeader">ID</th>
                <th className="eventsTableHeader">Name</th>
                <th className="eventsTableHeader">RFC</th>
                <th className="eventsTableHeader"></th>
              </tr>
            </thead>
            <tbody className="eventsTableBody">{table}</tbody>
          </table>
        </div>
      </Col>
    );
    this.setState({
      table1: tale2,
    });
  };

  recieveProps = (open) =>
    this.setState({ error: { open: open, type: this.state.error.type } });

  dataReport = (data) => {
    let dataReport = { data: data, userId: this.state.idDefault };
    this.setState({
      dataReport,
      reportsId: data,
      Changereport: true,
    });
  };

  dataDocuments = (dataPo, dataship) => {
    let array = [];
    dataPo.map((e) => {
      if (e.check) {
        let data = {
          DocCategoryId: e.DocCategoryId,
          ModuleId: e.ModuleId,
          UserId: this.state.idDefault,
        };
        array.push(data);
      }
      return e;
    });
    dataship.map((e) => {
      if (e.check) {
        let data = {
          DocCategoryId: e.DocCategoryId,
          ModuleId: e.ModuleId,
          UserId: this.state.idDefault,
        };
        array.push(data);
      }
      return e;
    });
    this.setState({
      dataDocuments: array,
      statusDocuemtens: array,
      Changedocument: true,
    });
  };

  render() {
    const { data, columns } = this.state;
    return (
      <>
        <Card className="myCard">
          <CardBody>
            <div style={{ textAlign: "center" }} className="col-md-12">
              <strong>Users</strong>
            </div>
            <Table
              columns={columns}
              data={data}
              itemsByPage={10}
              styles={styles}
              options={{
                pagination: true,
                search: true,
                downloads: {
                  xlsx: false,
                  pdf: false,
                },
              }}
            />
          </CardBody>
        </Card>
        <Modal
          open={this.state.active}
          size={"large"}
          dimmer={"inverted"}
          centered={false}
          scrolling
        >
          <Modal.Header className="headerModal">
            {this.state.edit === false ? "View User" : "Edit User"}
            <div className="iconHeader">
              <i
                className={'fas fa-edit'}
                // name="pencil"
                // size="small"
                disabled=""
                onClick={() => {
                  this.setState(
                    { edit: !this.state.edit, refres: true },
                    () => {
                      this.buildFormCreate();
                    }
                  );
                }}
              />
            </div>
          </Modal.Header>
          <Errors
            open={this.state.error.open}
            type={this.state.error.type}
            message={this.state.error.message}
            setProps={this.recieveProps}
          ></Errors>
          <Modal.Content scrolling>
            <div className="col-md-12">
              <strong style={{ color: "black" }}>User Information</strong>
            </div>
            <br></br>
            <div className="row" style={{ width: "100%", marginLeft: "20px" }}>
              {this.state.edit === false ? (
                <div style={{ marginTop: "13px" }} className="col-md-12">
                  <div className="row">{this.state.rows}</div>
                </div>
              ) : (
                <div className="col-md-10">
                  <div className="row">{this.state.CreateFormData}</div>
                </div>
              )}
            </div>
            <br></br>
            <div hidden={this.state.edit === true ? true : false}>
              <div className="col-md-12">
                <strong style={{ marginLeft: "-12px" }}>Customer List</strong>
              </div>
              <br></br>
              <div className="row">
                <div className="col-md-12">
                  <Table
                    data={this.state.itemsContact}
                    columns={this.state.columnsContact}
                    options={{
                      pagination: false,
                      search: false,
                      downloads: { xlsx: false, pdf: false },
                    }}
                  ></Table>
                </div>
              </div>
            </div>
            <br></br>
            <br></br>
            <div
              hidden={this.state.edit === true ? false : true}
              className="row"
            >
              <div className="col-md-4 col-lg-3 col-sm-12"></div>
              <div
                style={{ textAlign: "right" }}
                className="col-md-3 col-lg-2 col-sm-4"
              >
                <Button
                  variant="contained"
                  color="primary"
                  className="button"
                  onClick={this.addAll}
                >
                  Add All
                </Button>
              </div>
              <div
                style={{ textAlign: "center" }}
                className="col-md-2 col-lg-1 col-sm-4"
              >
                <Button
                  variant="contained"
                  color="primary"
                  className="button"
                  onClick={this.add}
                >
                  Add
                </Button>
              </div>
              <div className="col-md-2 col-lg-1 col-sm-4">
                <Button
                  variant="contained"
                  color="danger"
                  className="button"
                  onClick={this.deletAdd}
                >
                  Delete All
                </Button>
              </div>
            </div>
            <br></br>
            <br></br>
            <Row hidden={this.state.edit === true ? false : true}>
              {this.state.table1}
              {this.state.table2}
            </Row>
            <br></br>
            <br></br>
            <div hidden={this.state.edit === true ? false : true}>
              <ReportAsing
                refres={this.state.refres}
                reportsId={this.state.reportsId}
                statusDocuemtens={this.state.statusDocuemtens}
                edit={true}
                dataDocuments={this.dataDocuments}
                dataReport={this.dataReport}
                newSelected={this.state.clientesADD}
              ></ReportAsing>
            </div>
          </Modal.Content>
          <Modal.Actions className="actions_modalSelect">
            <div
              hidden={this.state.edit === true ? true : false}
              style={{ textAlign: "center" }}
              className="col-md-2 col-lg-12 col-sm-4"
            >
              <Button
                variant="contained"
                color="danger"
                className="button"
                onClick={this.handleOnClose}
              >
                Close
              </Button>
            </div>
            <div
              hidden={this.state.edit === true ? false : true}
              className="row"
            >
              <div className="col-md-6 col-lg-4 col-sm-12"></div>
              <div
                style={{ textAlign: "center" }}
                className="col-md-2 col-lg-2 col-sm-4"
              >
                <Button
                  variant="contained"
                  color="danger"
                  className="button"
                  onClick={this.handleOnClose}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-md-2 col-lg-1 col-sm-4">
                <Button
                  variant="contained"
                  color="primary"
                  className="button"
                  onClick={this.putUser}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
}
export default ListUser;
